import { abortableFetch } from '@eas/common-web';
import { EvidenceAPI } from '../../enums';
import { ProcessForm } from './minimal-distances-new-types';

export function createMinimalDistancesSource(body: ProcessForm) {
  return abortableFetch(`${EvidenceAPI.MINIMAL_DISTANCES}`, {
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    method: 'POST',
    body: JSON.stringify(body),
  });
}
